import React, { useState, useEffect } from 'react';
import { useCalendarTimeGrid } from '../hooks/useCalendarTimeGrid';
import { CALENDAR_CONSTANTS } from '../utils/constants';

const CalendarCurrentTimeLine = ({ className = '' }) => {
  const { currentTimePosition, startHour, endHour, hourHeight } = useCalendarTimeGrid();
  const [position, setPosition] = useState(currentTimePosition);

  useEffect(() => {
    const updatePosition = () => {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();

      if (hours < startHour || hours >= endHour) {
        setPosition(null);
        return;
      }

      const newPosition = CALENDAR_CONSTANTS.HEADER_HEIGHT +
        ((hours - startHour) + minutes / 60) * hourHeight;
      setPosition(newPosition);
    };

    updatePosition();
    const interval = setInterval(updatePosition, 60000);

    return () => clearInterval(interval);
  }, [startHour, endHour, hourHeight]);

  if (position === null) {
    return null;
  }

  return (
    <div
      className={`calendar-current-time ${className}`}
      style={{ top: position }}
      aria-hidden="true"
    />
  );
};

export default CalendarCurrentTimeLine;
